import React, { useState, useEffect } from 'react';
import { Users, ShieldCheck, Activity, KeyRound, CheckCircle2, MoreHorizontal, Download, ArrowUpRight, ArrowDownRight, TrendingUp } from 'lucide-react';
import Swal from 'sweetalert2';
import Chart from 'react-apexcharts';

const AdminDashboard: React.FC = () => {
  const [stats, setStats] = useState({ totalUsers: 0, totalCampaigns: 0, activeUsers: 0 });
  const [requests, setRequests] = useState<any[]>([]);
  // NAYA STATE: Withdrawals ke liye
  const [withdrawals, setWithdrawals] = useState<any[]>([]);

  // Fetch Dashboard Data (Registrations & Stats)
  const fetchDashboardData = async () => {
    try {
      const response = await fetch('https://motilalalgo.com/api/admin/dashboard-data');
      const data = await response.json();
      if (data.success) {
        setStats({ totalUsers: data.totalUsers, totalCampaigns: data.totalCampaigns, activeUsers: data.activeUsers });
        setRequests(data.recentUsers);
      }
    } catch (error) {
      console.error("Failed to fetch dashboard data", error);
    }
  };

  // NAYA FUNCTION: Pending Withdrawals fetch karne ke liye
  const fetchWithdrawals = async () => {
    try {
      const response = await fetch('https://motilalalgo.com/api/admin/withdrawals/pending');
      // const response = await fetch('http://localhost:10001/api/admin/withdrawals/pending');
      const data = await response.json();
      if (data.success) {
        setWithdrawals(data.requests);
      }
    } catch (error) {
      console.error("Failed to fetch withdrawals", error);
    }
  };

  // Ek hi useEffect mein dono data load honge
  useEffect(() => {
    fetchDashboardData();
    fetchWithdrawals(); 
  }, []);

  // Mock Data for Candlestick Chart (Trading view)
  const chartSeries = [{
    name: 'candle',
    data: [
      { x: new Date('2026-04-01').getTime(), y: [6500, 6600, 6450, 6580] },
      { x: new Date('2026-04-02').getTime(), y: [6580, 6650, 6520, 6540] },
      { x: new Date('2026-04-03').getTime(), y: [6540, 6560, 6400, 6420] },
      { x: new Date('2026-04-04').getTime(), y: [6420, 6600, 6400, 6550] },
      { x: new Date('2026-04-05').getTime(), y: [6550, 6700, 6500, 6680] },
      { x: new Date('2026-04-06').getTime(), y: [6680, 6750, 6600, 6620] },
      { x: new Date('2026-04-07').getTime(), y: [6620, 6800, 6580, 6780] },
      { x: new Date('2026-04-08').getTime(), y: [6780, 6820, 6700, 6750] },
      { x: new Date('2026-04-09').getTime(), y: [6750, 6900, 6700, 6880] },
      { x: new Date('2026-04-10').getTime(), y: [6880, 6950, 6800, 6850] },
    ]
  }];

  const chartOptions: any = {
    chart: { type: 'candlestick', toolbar: { show: false }, fontFamily: 'Urbanist, sans-serif' },
    plotOptions: { candlestick: { colors: { upward: '#10b981', downward: '#ef4444' }, wick: { useFillColor: true } } },
    xaxis: { type: 'datetime', labels: { style: { colors: '#94a3b8', fontWeight: 600 } }, axisBorder: { show: false }, axisTicks: { show: false } },
    yaxis: { labels: { style: { colors: '#94a3b8', fontWeight: 600 }, formatter: (value: number) => `₹${value}` }, tooltip: { enabled: true } },
    grid: { borderColor: '#f1f5f9', strokeDashArray: 4 },
    tooltip: { theme: 'light' }
  };

  const handleGenerateCredentials = (user: any) => {
    Swal.fire({
      title: 'Assign Credentials',
      html: `
        <div style="text-align: left; margin-top: 10px;">
           <label style="font-size: 13px; font-weight: bold; color: #475569;">Login ID</label>
           <input type="text" id="swal-login-id" class="swal2-input" style="margin-top: 5px; width: 100%; max-width: 100%;" placeholder="e.g. USR${user.id}">
           
           <label style="font-size: 13px; font-weight: bold; color: #475569; margin-top: 15px; display: block;">Password</label>
           <input type="text" id="swal-password" class="swal2-input" style="margin-top: 5px; width: 100%; max-width: 100%;" placeholder="Set Password">
        </div>
      `,
      showCancelButton: true,
      confirmButtonColor: '#3b36a4', 
      confirmButtonText: 'Approve & Save',
      preConfirm: () => {
        const loginId = (document.getElementById('swal-login-id') as HTMLInputElement).value;
        const password = (document.getElementById('swal-password') as HTMLInputElement).value;
        if (!loginId || !password) {
          Swal.showValidationMessage('Both fields are required');
        }
        return { loginId, password };
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const resp = await fetch(`https://motilalalgo.com/api/admin/approve-user/${user.id}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(result.value)
          });
          const data = await resp.json();
          if (data.success) {
            Swal.fire('Success!', 'User is now active.', 'success');
            fetchDashboardData(); // Refetch updated list
          } else {
            Swal.fire('Error', data.error, 'error');
          }
        } catch (error) {
          Swal.fire('Error', 'Server Error', 'error');
        }
      }
    });
  };

  // NAYA FUNCTION: Withdrawal Approve/Reject handle karne ke liye
  const handleWithdrawalAction = (req: any, actionStatus: string) => {
    Swal.fire({
      title: `Are you sure you want to ${actionStatus === 'SUCCESS' ? 'APPROVE' : 'REJECT'} this withdrawal?`,
      text: `Amount: ₹${req.amount} | User: ${req.first_name}`,
      icon: actionStatus === 'SUCCESS' ? 'success' : 'warning',
      showCancelButton: true,
      confirmButtonColor: actionStatus === 'SUCCESS' ? '#10b981' : '#ef4444',
      confirmButtonText: `Yes, ${actionStatus === 'SUCCESS' ? 'Approve' : 'Reject'}`
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const resp = await fetch(`https://motilalalgo.com/api/admin/withdrawals/update-status`, {
          // const resp = await fetch(`http://localhost:10001/api/admin/withdrawals/update-status`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
              transaction_id: req.trx_id, 
              user_id: req.user_id, 
              amount: req.amount, 
              status: actionStatus 
            })
          });
          const data = await resp.json();
          if (data.success) {
            Swal.fire('Done!', data.message, 'success');
            fetchWithdrawals(); // List ko turant refresh karo
          } else {
            Swal.fire('Error', data.error, 'error');
          }
        } catch (error) {
          Swal.fire('Error', 'Server Error', 'error');
        }
      }
    });
  };

  return (
    <div className="max-w-[1600px] mx-auto space-y-6 pb-10">
      
      {/* HEADER TABS - Trading Style */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-white p-4 rounded-2xl shadow-sm border border-slate-100">
        <div className="flex flex-wrap items-center gap-3">
          <button className="px-5 py-2.5 bg-slate-50 text-slate-500 rounded-xl font-bold text-sm flex items-center gap-2 hover:bg-slate-100 transition-colors">
            <div className="w-6 h-6 rounded-full bg-slate-200 flex items-center justify-center">N</div> Nifty 50
          </button>
          <button className="px-5 py-2.5 bg-blue-50 text-blue-600 rounded-xl font-bold text-sm flex items-center gap-2 border border-blue-100 hover:bg-blue-100 transition-colors">
            <div className="w-6 h-6 rounded-full bg-blue-200 flex items-center justify-center text-blue-700">S</div> Sensex
          </button>
          <button className="px-5 py-2.5 bg-slate-50 text-slate-500 rounded-xl font-bold text-sm flex items-center gap-2 hover:bg-slate-100 transition-colors">
            <div className="w-6 h-6 rounded-full bg-slate-200 flex items-center justify-center">B</div> Bank Nifty
          </button>
        </div>
        <button className="bg-[#3b36a4] hover:bg-[#2d2780] text-white px-5 py-2.5 rounded-xl font-bold shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2 text-sm w-full sm:w-auto justify-center">
          <Download size={16} /> Get Report
        </button>
      </div>

      {/* CHART & STATS ROW */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        
        <div className="lg:col-span-2 bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
          <div className="flex justify-between items-start mb-6">
            <div>
              <h2 className="text-xl font-black text-slate-800">Algo Performance Chart</h2>
              <p className="text-sm text-slate-400 font-medium">Real-time mock trading data</p>
            </div>
            <div className="text-right">
              <p className="text-sm font-bold text-slate-400">Current Value</p>
              <h3 className="text-2xl font-black text-emerald-500 flex items-center gap-2 justify-end">₹68,500.00 <TrendingUp size={20} /></h3>
            </div>
          </div>
          <div className="h-[300px] w-full">
            <Chart options={chartOptions} series={chartSeries} type="candlestick" height="100%" />
          </div>
        </div>

        <div className="flex flex-col gap-6">
          <StatCard title="Total Clients" value={stats.totalUsers.toString()} change="+Active" isUp={true} />
          <StatCard title="Total Campaigns" value={stats.totalCampaigns.toString()} change="Pending" isUp={false} />
          <div className="bg-[#2d2780] text-white p-6 rounded-2xl shadow-lg relative overflow-hidden flex-1 flex flex-col justify-center">
            <div className="absolute -right-10 -top-10 w-40 h-40 bg-white/10 rounded-full blur-2xl"></div>
            <h3 className="text-lg font-bold text-indigo-200 mb-1">Active Accounts</h3>
            <p className="text-4xl font-black mb-4">{stats.activeUsers}</p>
            <button className="bg-white text-[#2d2780] font-bold py-2.5 px-4 rounded-xl text-sm hover:bg-slate-50 transition-colors w-fit">
              Manage Users
            </button>
          </div>
        </div>
      </div>

      {/* REGISTRATION TABLE */}
      <div className="bg-white border border-slate-100 rounded-2xl shadow-sm overflow-hidden">
        <div className="px-6 py-5 border-b border-slate-50 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div>
            <h2 className="text-lg font-black text-slate-800">Recent Registrations</h2>
            <p className="text-sm text-slate-400 font-medium">Approve new trading accounts.</p>
          </div>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse whitespace-nowrap min-w-[950px]">
            <thead>
              <tr className="bg-slate-50/50 text-xs uppercase tracking-widest text-slate-400 font-bold border-b border-slate-100">
                <th className="px-6 py-4">User Details</th>
                <th className="px-6 py-4">Contact</th>
                <th className="px-6 py-4">Documents</th>
                <th className="px-6 py-4">Status</th>
                <th className="px-6 py-4 text-right">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {requests.map((req) => (
                <tr key={req.id} className="hover:bg-slate-50/50 transition-colors">
                  <td className="px-6 py-4">
                    <div className="font-bold text-slate-800">{req.first_name} {req.last_name}</div>
                    <div className="text-xs font-semibold text-slate-400 mt-0.5">REQ-{req.id} • {req.city}</div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="font-bold text-slate-700 text-sm">{req.mobile_number}</div>
                    <div className="text-xs font-medium text-slate-400 mt-0.5">{req.email}</div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex flex-col items-start gap-1.5">
                      <span className="text-xs font-bold text-slate-600 bg-slate-100 px-2 py-1 rounded-md border border-slate-200">Aadhar: {req.aadhar_no}</span>
                      <span className="text-xs font-bold text-slate-600 bg-slate-100 px-2 py-1 rounded-md border border-slate-200">PAN: {req.pan_no}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    {!req.login_id ? (
                      <span className="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-full bg-amber-50 text-amber-600 text-xs font-bold">
                        <span className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse"></span> Pending
                      </span>
                    ) : (
                      <span className="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-full bg-emerald-50 text-emerald-600 text-xs font-bold">
                        <CheckCircle2 size={14} /> Active
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-4 text-right">
                    {!req.login_id ? (
                      <button onClick={() => handleGenerateCredentials(req)} className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#3b36a4] text-white text-xs font-bold rounded-xl hover:bg-[#2d2780] transition-colors shadow-md">
                        <KeyRound size={14} /> Approve
                      </button>
                    ) : (
                      <div className="text-xs font-bold text-emerald-600 bg-emerald-50 py-1.5 px-3 rounded-lg inline-block">
                        ID: {req.login_id}
                      </div>
                    )}
                  </td>
                </tr>
              ))}
              {requests.length === 0 && (
                <tr><td colSpan={5} className="text-center py-8 text-slate-400">No recent registrations.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* PENDING WITHDRAWALS TABLE (NAYA ADD KIYA HAI) */}
      <div className="bg-white border border-slate-100 rounded-2xl shadow-sm overflow-hidden mt-6">
        <div className="px-6 py-5 border-b border-slate-50 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div>
            <h2 className="text-lg font-black text-slate-800">Pending Withdrawals</h2>
            <p className="text-sm text-slate-400 font-medium">Approve client withdrawal requests here.</p>
          </div>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse whitespace-nowrap min-w-[950px]">
            <thead>
              <tr className="bg-slate-50/50 text-xs uppercase tracking-widest text-slate-400 font-bold border-b border-slate-100">
                <th className="px-6 py-4">User Info</th>
                <th className="px-6 py-4">Bank Details</th>
                <th className="px-6 py-4">Amount</th>
                <th className="px-6 py-4 text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {withdrawals.map((req) => (
                <tr key={req.id} className="hover:bg-slate-50/50 transition-colors">
                  <td className="px-6 py-4">
                    <div className="font-bold text-slate-800">{req.first_name} {req.last_name}</div>
                    <div className="text-xs font-semibold text-slate-400 mt-0.5">Trx ID: {req.trx_id}</div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-sm font-bold text-slate-700">A/c: {req.account_number}</div>
                    <div className="text-xs font-medium text-slate-400 mt-0.5">IFSC: {req.ifsc_code}</div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-sm font-black text-emerald-600">₹{req.amount}</div>
                  </td>
                  <td className="px-6 py-4 text-right">
                    <div className="flex justify-end gap-2">
                      <button onClick={() => handleWithdrawalAction(req, 'SUCCESS')} className="px-4 py-2 bg-emerald-500 text-white text-xs font-bold rounded-xl hover:bg-emerald-600 transition-colors shadow-md">
                        Approve
                      </button>
                      <button onClick={() => handleWithdrawalAction(req, 'REJECTED')} className="px-4 py-2 bg-red-500 text-white text-xs font-bold rounded-xl hover:bg-red-600 transition-colors shadow-md">
                        Reject
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {withdrawals.length === 0 && (
                <tr><td colSpan={4} className="text-center py-8 text-slate-400 font-bold">No pending withdrawals.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
};

const StatCard = ({ title, value, change, isUp }: any) => (
  <div className="bg-white p-5 rounded-2xl shadow-sm border border-slate-100 flex items-center justify-between group hover:border-[#3b36a4]/30 transition-colors">
    <div>
      <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">{title}</p>
      <h3 className="text-xl font-black text-slate-800">{value}</h3>
    </div>
    <div className={`text-sm font-bold flex items-center gap-1 px-2.5 py-1 rounded-lg ${isUp ? 'bg-emerald-50 text-emerald-600' : 'bg-amber-50 text-amber-600'}`}>
      {isUp ? <ArrowUpRight size={16} /> : <TrendingUp size={16} />} {change}
    </div>
  </div>
);

export default AdminDashboard;